import { render, staticRenderFns } from "./studyModules.vue?vue&type=template&id=2abca476&"
import script from "./studyModules.vue?vue&type=script&lang=js&"
export * from "./studyModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports